export type MessageSettings = { version: number; default_title: string; reward_amount: string; referral_title: string; referral_body: string };
export const renderRewardTemplate = (text: string, amount: string) => text.replaceAll('{amount}', () => amount.trim() || 'xxx');
